var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-item-group",
    {
      staticClass: "flex w-full",
      class: { "px-2": !_vm.altPriceAvailable },
      attrs: { mandatory: "" },
      on: {
        change: function ($event) {
          return _vm.$emit("input", $event)
        },
      },
      model: {
        value: _vm.selectMembership,
        callback: function ($$v) {
          _vm.selectMembership = $$v
        },
        expression: "selectMembership",
      },
    },
    [
      _c("v-item", {
        attrs: {
          value: {
            id: _vm.membership.id,
            price_id: _vm.membership.price_id,
          },
        },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function ({ active, toggle }) {
              return [
                _c(
                  "v-card",
                  {
                    staticClass:
                      "soli-round text-center flex-1 justify-center custom-card-round",
                    class: {
                      "mb-2": !_vm.button2,
                      "px-2": !!(active && _vm.altPriceAvailable),
                      "px-3": !_vm.altPriceAvailable,
                      "py-3": _vm.altPriceAvailable,
                    },
                    attrs: {
                      flat: "",
                      outlined: !!(active && _vm.altPriceAvailable),
                    },
                    on: { click: toggle },
                  },
                  [
                    _c(
                      "div",
                      { class: { "d-inline-block": _vm.altPriceAvailable } },
                      [
                        _c("div", { staticClass: "flex gap-2" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "accent--text font-semibold whitespace-nowrap",
                              class: { "text-xs": !active },
                            },
                            [
                              _vm._v(
                                "\n                        SAVE " +
                                  _vm._s(_vm.membership.discount) +
                                  "\n                    "
                              ),
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "soli-grey",
                              class: { "text-xs": !active },
                              staticStyle: {
                                "text-decoration": "line-through",
                              },
                            },
                            [
                              _vm._v(
                                "\n                        " +
                                  _vm._s(_vm.membership.original_amount) +
                                  "\n                    "
                              ),
                            ]
                          ),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "flex gap-1 align-end soli-grey" },
                          [
                            !!(active && _vm.altPriceAvailable)
                              ? _c(
                                  "v-icon",
                                  { attrs: { color: "soli-status-green" } },
                                  [_vm._v("check")]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass: "font-semibold",
                                class: [active ? "text-2xl" : "text-lg"],
                              },
                              [
                                _vm._v(
                                  "\n                        " +
                                    _vm._s(_vm.membership.amount) +
                                    "\n                    "
                                ),
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticClass: "text-xs" }, [
                              _vm._v("/month"),
                            ]),
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "flex soli-grey whitespace-nowrap",
                            class: [
                              active ? "text-sm" : "text-xs",
                              {
                                "justify-center": _vm.altPriceAvailable,
                              },
                            ],
                          },
                          [
                            _vm._v(
                              "\n                    " +
                                _vm._s(_vm.membership.package) +
                                "\n                "
                            ),
                          ]
                        ),
                      ]
                    ),
                  ]
                ),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _vm.altPriceAvailable
        ? _c("v-item", {
            attrs: {
              value: {
                id: _vm.membership.id,
                price_id: _vm.membership.alt_price_id,
              },
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function ({ active, toggle }) {
                    return [
                      _c(
                        "v-card",
                        {
                          staticClass:
                            "soli-round py-3 text-center flex-1 justify-center custom-card-round",
                          class: {
                            "mb-2": !_vm.button2,
                            "px-2": active,
                          },
                          attrs: { flat: "", outlined: active },
                          on: { click: toggle },
                        },
                        [
                          _c("div", { staticClass: "d-inline-block" }, [
                            _c("div", { staticClass: "flex gap-2" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "accent--text font-semibold whitespace-nowrap text-md",
                                  class: { "text-xs": !active },
                                },
                                [
                                  _vm._v(
                                    "\n                        SAVE " +
                                      _vm._s(_vm.membership.alt_discount) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "soli-grey",
                                  class: { "text-xs": !active },
                                  staticStyle: {
                                    "text-decoration": "line-through",
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                        " +
                                      _vm._s(_vm.membership.alt_amount) +
                                      "\n                    "
                                  ),
                                ]
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "div",
                              { staticClass: "flex gap-1 align-end soli-grey" },
                              [
                                active
                                  ? _c(
                                      "v-icon",
                                      { attrs: { color: "soli-status-green" } },
                                      [_vm._v("check")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  {
                                    staticClass: "font-semibold",
                                    class: [active ? "text-2xl" : "text-lg"],
                                  },
                                  [
                                    _vm._v(
                                      "\n                        " +
                                        _vm._s(_vm.membership.alt_amount) +
                                        "\n                    "
                                    ),
                                  ]
                                ),
                                _vm._v(" "),
                                _c("div", { staticClass: "text-xs" }, [
                                  _vm._v("/month"),
                                ]),
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "soli-grey flex whitespace-nowrap justify-center",
                                class: [active ? "text-sm" : "text-xs"],
                              },
                              [
                                _vm._v(
                                  "\n                    " +
                                    _vm._s(_vm.membership.alt_package) +
                                    "\n                "
                                ),
                              ]
                            ),
                          ]),
                        ]
                      ),
                    ]
                  },
                },
              ],
              null,
              false,
              2121176839
            ),
          })
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }